/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EquipementDto } from '../../models/equipement-dto';

export interface GetEquipementById$Params {
  /**
   * Id equipement pour lequel il faut récupérer l'équipement.
   */
  idEquipement: string;
}

export function getEquipementById(
  http: HttpClient,
  rootUrl: string,
  params: GetEquipementById$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<EquipementDto>> {
  const rb = new RequestBuilder(rootUrl, getEquipementById.PATH, 'get');
  if (params) {
    rb.path('idEquipement', params.idEquipement, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EquipementDto>;
    })
  );
}

getEquipementById.PATH = '/v1/equipements/{idEquipement}';
